@if (variant() !== null) {
  <span class="notification-badge mat-font-label-sm" [class]="'notification-badge--' + variant()">{{ percent() }}%</span>
}